import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let singleton: SupabaseClient | null | undefined;

export function browserSupabase(): SupabaseClient | null {
  if (singleton !== undefined) {
    return singleton;
  }
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
  if (
    url === undefined ||
    anonKey === undefined ||
    url.trim() === "" ||
    anonKey.trim() === "" ||
    anonKey.includes("placeholder")
  ) {
    singleton = null;
    return singleton;
  }
  singleton = createClient(url, anonKey, {
    auth: { autoRefreshToken: true, detectSessionInUrl: true, persistSession: true },
  });
  return singleton;
}
